/**
 * Created by liwenqiang on 2018/3/26.
 */

const $ = require('jquery');

$(document).on('scroll', function scrollEvent() {
    let scrollTop = $(document).scrollTop();
    let screenHeight = $(window).height();

    if (scrollTop > screenHeight / 2) {
        return $('#toTop').show();
    }
    $('#toTop').hide();
});

let space;
$('#toTop').on('click', function (){
    space = $(document).scrollTop()/12;
    scrollToTop();
});

function scrollToTop() {
    window.requestAnimationFrame(function scrollToTopRAF() {
        let scrollTop = $(document).scrollTop() - space;

        if(scrollTop > 0){
            $(document).scrollTop(scrollTop);
            scrollToTop();
        }else{
            $(document).scrollTop(0);
        }
    })
}


//////////////////
// WEBPACK FOOTER
// ./src/global/js/toTop.js
// module id = 8
// module chunks = 0 1 2